import profileImage from "../assets/img/avatars/profileImage.jpg";
import AudioOrder from "views/admin/orders/components/audioOrder";
import { MdOutlineVoiceOverOff } from "react-icons/md";
import { BASE_URL } from "utils/utils";
import ContractorDetails from "views/admin/orders/components/contractorDetails";
import LocationOrder from "views/admin/orders/components/locationOrder";
import OrderDetails from "views/admin/orders/components/orderDetails";
import DeleteOrder from "views/admin/orders/components/deleteOrder";
import { localizeContractorSkill } from "utils/localization";

const OrdersColumn = (refetch) => [
  {
    Header: "رقم الطلب",
    accessor: "orderNumber",
    Cell: ({ row }) => (
      <span className="text-sm font-semibold">
        {row.original.orderNumber}
      </span>
    ),
  },
  {
    Header: "اسم المستخدم",
    Cell: ({ row }) => {
      return (
        <span className="text-sm font-semibold">{row.original.user?.name}</span>
      );
    },
  },
  {
    Header: "رقم المستخدم",
    Cell: ({ row }) => {
      return (
        <a
          className="hover:underline"
          href={`tel:${row.original.user?.phoneNumber}`}
        >
          {row.original.user?.phoneNumber}
        </a>
      );
    },
  },
  {
    Header: "تفاصيل الطلب",
    Cell: ({ row }) => (
      <div className="flex items-center justify-start">
        <OrderDetails data={row.original} />
      </div>
    ),
  },
  {
    Header: "الموقع",
    accessor: "text",
    Cell: ({ row }) => {
      return (
        <LocationOrder
          address={row.original.address}
          location={row.original.location}
        />
      );
    },
  },
  {
    Header: "تسجيل صوتي",
    accessor: "voice",
    Cell: ({ row }) => {
      return row.values.voice ? (
        <AudioOrder audio={row.values.voice} />
      ) : (
        <MdOutlineVoiceOverOff color="red" size={25} />
      );
    },
  },
  {
    Header: "الصورة",
    accessor: "desiredDesign",
    Cell: ({ row }) => {
      return (
        <img
          src={
            row.values.desiredDesign
              ? `${BASE_URL}/${row.values.desiredDesign}`
              : profileImage
          }
          alt="offer"
          className="h-10 w-10 rounded-full border border-gray-200"
          crossOrigin="anonymous"
        />
      );
    },
  },
  {
    Header: "المهارات المطلوبة",
    accessor: "skillRequired",
    Cell: ({ row }) => {
      return (
        <span className="text-sm font-semibold">
          {localizeContractorSkill(row.values.skillRequired)}
        </span>
      );
    },
  },
  {
    Header: "مطلوب مواد",
    accessor: "materialRequired",
    Cell: ({ row }) => {
      return (
        <span
          className={`text-sm font-semibold ${
            row.values.materialRequired ? "text-green-500" : "text-red-500"
          }`}
        >
          {row.values.materialRequired ? "نعم" : "لا"}
        </span>
      );
    },
  },
  {
    Header: "زيارة مقاول",
    accessor: "contractorVisit",
    Cell: ({ row }) => {
      return (
        <span
          className={`text-sm font-semibold ${
            row.values.contractorVisit ? "text-green-500" : "text-red-500"
          }`}
        >
          {row.values.contractorVisit ? "نعم" : "لا"}
        </span>
      );
    },
  },
  {
    Header: "التاريخ",
    accessor: "createdAt",
    Cell: ({ row }) => {
      return (
        <span className="text-sm font-semibold">
          {new Date(row.values.createdAt).toLocaleDateString("ar-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",

            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      );
    },
  },
  {
    Header: "المقاولون",
    Cell: ({ row }) => (
      <div className="flex items-center justify-start">
        <ContractorDetails data={row.original} />
      </div>
    ),
  },
  {
    Header: "إجراء",
    Cell: ({ row }) => <DeleteOrder id={row.original.id} refetch={refetch} />,
  },
];

export default OrdersColumn;
